import { Button, Card, CardContent, CardHeader, Divider, makeStyles, Typography } from '@material-ui/core'
import { DropzoneArea } from 'material-ui-dropzone'
import React, { useState } from 'react'

const useStyles = makeStyles(theme => ({
    root: {
        background: '#f1f1f1',
        flexGrow: 1,
    },
    button: {
        marginTop: theme.spacing(2)
    }
}))


const FileUpload = props => {
    const [uploadButton, setUploadButton] = useState(false)
    const [file, setFile] = useState([])
    const classes = useStyles()
    return (
        <Card elevation={5} className={classes.root} data-tour="upload-area">
            <CardHeader
                title={props.title ? props.title : 'بارگذاری فایل'}
            />
            <Divider />
            <CardContent>
                {!props.disabled ? (
                    <>
                        <DropzoneArea
                            filesLimit={props.disabled ? 0 : 1}
                            dropzoneText={'فایل را اینجا رها کنید یا کلیک کنید'}
                            acceptedFiles={props.fileTypes}
                            maxFileSize={4e8}
                            onDrop={() => setUploadButton(true)}
                            onDelete={() => setUploadButton(false)}
                            onChange={file => setFile(file[0])}
                            showFileNames
                            showAlerts={false}
                        />
                        <Button
                            variant='contained'
                            fullWidth
                            className={classes.button}
                            color='primary'
                            disabled={!uploadButton}
                            onClick={() => props.upload(file)}
                        >
                            <Typography>
                                آپلود
                            </Typography>
                        </Button>
                    </>
                ) : (
                        <Typography variant='h5' align='center'>
                            امکان آپلود فایل وجود ندارد.
                        </Typography>
                    )}
            </CardContent>
        </Card >
    )
}

export default FileUpload